export interface PromotionInfo {
  campaignCode: string;
  endDate: number; // Unix timestamp in milliseconds
}

export interface StarterPackagePromotionInfo extends PromotionInfo {
  couponInfo?: Record<string, CouponConfig>;
  priceConfig?: PromotionPriceProps;
  bannerConfig?: PromotionBannerProps;
  discountPercentage: number;
}

export interface SingleProductPromotionInfo extends PromotionInfo {
  maxDiscountLicense: number;
  discountedProducts: DiscountProduct[];
  priceConfig?: PromotionPriceProps;
  bannerConfig?: PromotionBannerProps;
  packageGroups?: PackageGroup[];
  timeWindow?: TimeWindow;
}

// Union type for API responses that can return either promotion type
export type AnyPromotionInfo = SingleProductPromotionInfo | StarterPackagePromotionInfo;

export interface DiscountProduct {
  productCode: string;
  discountQuantity: number;
  discountAmount: number;
}

export interface CouponConfig {
  couponCode: string;
  discountPercentage?: number;
  discountAmount?: number;
}

export interface TimeWindow {
  startDate: number; // Unix timestamp
  endDate: number; // Unix timestamp
}

export interface PackageGroup {
  groupName: string;
  packages: Package[];
  trialProducts: PreDefinedProduct[];
  mostPopular?: boolean;
}

export interface Package {
  discountedProducts: PreDefinedProduct[];
  originPrice: number;
  discountedPrice: number;
}

export interface PreDefinedProduct {
  productCode: string;
  quantity: number;
  originPrice?: number,
  discountedPrice?: number,
}

export interface PromotionCampaignProps {
  endDate: number;
  priceConfig?: PromotionPriceProps;
  bannerConfig?: PromotionBannerProps;
}

export interface PromotionPriceProps {
  currentPrice?: number;
  discountPrice?: number;
  priceUnit?: string;
}

export interface PromotionBannerProps {
  bannerStyle?: Record<string, string>;
  promotionPrefix: PromotionCampaignPrefix;
  hidePromotionPrice?: boolean;
}

export enum PromotionCampaignPrefix {
  DEFAULT = 'DEFAULT',
  HOLIDAYPROMO = 'HOLIDAYPROMO',
  NEWYEAR2025 = 'NEWYEAR2025',
  BLACKFRIDAY = 'BLACKFRIDAY',
  NEWYEAR2026 = 'NEWYEAR2026',
}

export enum PromoBannerComponentName {
  LEFT_BACKGROUND = 'LEFT_BACKGROUND',
  MID_BACKGROUND = 'MID_BACKGROUND',
  HOUR_GLASS = 'HOUR_GLASS',
  RIGHT_BACKGROUND = 'RIGHT_BACKGROUND',
}
